import { WellStatusBase } from './base/well-status-base';

export class WellStatus extends WellStatusBase { }